import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AppGuardedRoutes } from './app-guarded-routes'
import { calculateAppDefaultRoute } from './app.utils'
import { AuthGuardWithForcedLogin } from './modules/auth/auth-guard-with-forced-login.service'

import { environment } from '../environments/environment'

export const routes: Routes = [
  {
    path: '',
    redirectTo: calculateAppDefaultRoute(),
    pathMatch: 'full',
  },
  {
    path: 'start',
    loadComponent: () =>
      import('./modules/auth/start-layout/start-layout.component').then(
        ({ StartLayoutComponent }) => StartLayoutComponent
      ),
    loadChildren: () => import('./modules/auth/auth-routes').then(({ AuthRoutes }) => AuthRoutes),
  },

  {
    path: 'login-failure',
    loadComponent: () =>
      import('@flowx/designer/shared/components/login-failure/login-failure.component').then(
        ({ LoginFailureComponent }) => LoginFailureComponent
      ),
  },
  {
    path: 'guard',
    canActivate: [AuthGuardWithForcedLogin],
    loadComponent: () =>
      import('./modules/auth/app-guard/app-guard.component').then(
        ({ AppGuardComponent }) => AppGuardComponent
      ),
    children: AppGuardedRoutes,
  },
  {
    path: '403',
    loadComponent: () =>
      import('@flowx/designer/modules/core/authorization-error/authorization-error.component').then(
        ({ AuthorizationErrorComponent }) => AuthorizationErrorComponent
      ),
  },
  { path: '**', redirectTo: '403' },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: environment.debug.ngRouter,
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
